import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";
import { z } from "zod";
export const SpaceUnit = z.enum(["Pixels", "Rem", "Percent"]);
export const SpaceValue = z.object({
    unit: DimensionUnit,
    measure: z.number(),
});
export const SpaceTokenData = tokenAliasOrValue(SpaceValue);
